// stimulus controller
// karrot
import "controllers"

function setColorSchemeClass() {
  const html = document.documentElement;

  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    html.classList.remove('light-theme');
    html.classList.add('dark-theme', "dark");
  } else {
    html.classList.remove('dark-theme', "dark");
    html.classList.add('light-theme');
  }
}

setColorSchemeClass();
window.matchMedia("(prefers-color-scheme: dark)").addEventListener('change', setColorSchemeClass);